import { Config } from 'domain/configs/models/config';
import {
  ConfigCatalogPayload,
  ConfigPayload,
} from 'services/interfaces/config';

export function mergeConfigCatalogWithValues(
  catalog: ConfigCatalogPayload[],
  installationValues: ConfigPayload[],
): Config[] {
  return catalog.map((catalogConfig) => {
    const config = new Config({
      name: catalogConfig.name,
      description: catalogConfig.description,
      type: catalogConfig.type,
      readonly: catalogConfig.readonly,
      domain: catalogConfig.domain,
      options: catalogConfig.options || undefined,
    });
    const installationValue = installationValues.find(
      (value) => value.nome === catalogConfig.name,
    );

    if (installationValue) {
      config.trueValue = installationValue.valor;
      config.code = installationValue.codigo;
      config.createdAt = installationValue.created_at;
      config.updatedAt = installationValue.updated_at;
    }

    return config;
  });
}
